import { Login } from "@/contexts/autorizacao/usuario/pages/login/Login";
import { Route } from "react-router";

// Rotas públicas (fora do layout autenticado).
export function usuarioPublicRoutes() {
  return (
    <>
      <Route path="/login" element={<Login />} />
    </>
  );
}
